import Vue from 'vue'
import Vuex from 'vuex'
import { formatted_date, formatted_time } from '../common/Helper/Support/DateTimeHelper'


// import Profile from "./modules/Profile/Profile";
import ActivityType from "./modules/ActivityType/activity_type";
import Person from "./modules/Person/person";
import Tags from "./modules/Tags/tags";
import ContactType from "./modules/Type/type";
import PhoneEmailType from "./modules/Type/phoneEmailType";
import Owner from "./modules/Owner/owner";
import Status from "./modules/Status/status";
import Additional from "./modules/Additional/additional";
import Pipeline from "./modules/Pipeline/pipeline";
import Stage from "./modules/Stage/stage";
import Organization from "./modules/Organization/organization";
import Example from './modules/Example';
import Deal from './modules/Deal/deals';
// import Notification from './modules/Setting/notification';
import CheckEmailSetting from './modules/Setting/checkEmailDeliverySetting';
import PhoneNumber from './modules/Phone/phones';
import Language from './modules/Language/language';
// import {formatted_date, formatted_time} from "../Helpers/Helpers";

//Import you module here
import Support from "./modules/Common/Support";
import Notifications from "./modules/Common/Notifications";
import Notification from "./modules/Common/Settings/Notification";
// import User from "./modules/Common/User";
import NotificationEvent from "./modules/Common/Settings/NotificationEvent";
import dashboard from "../app/MailerStore/modules/Dashboard/dashboard";
import stats from "../app/MailerStore/modules/Email/stats";
// import Settings from "./modules/Common/Settings/Settings";
import Role from "./modules/Common/Role";
import CustomField from "./modules/Common/Settings/CustomField/CustomField";
import Profile from "./modules/Common/Profile";
import TenantSettings from "./modules/Tenant/TenantSettings";
import Department from "./modules/Tenant/Departments";
import Departments from "./modules/Tenant/Departments";
import Designations from "./modules/Tenant/Designations";
import WorkingShifts from "./modules/Tenant/WorkingShift";
import Roles from "./modules/Tenant/Roles";
import EmploymentStatuses from "./modules/Tenant/EmployeeStatuses";
import Employees from "./modules/Tenant/Employees";
import CalendarFilter from "./modules/Tenant/CalendarFilter";
import Payrun from "./modules/Tenant/Payrun";
import campaign from "../app/Store/modules/Campaign/campaign";
import segment from "../app/Store/modules/Segment/segment";
import lists from "../app/Store/modules/Lists/lists";
import subscriber from "../app/Store/modules/Subscriber/subscriber";

//Recrutter
// import settings from './modules/settings/Settings';
import User from './modules/user/User';
import theme from './modules/theme/Theme';
import userAndRoles from './modules/user/UserRoles';
import notificationSettings from './modules/settings/NotificationSettings';
import statuses from "./modules/statuses/Statuses";
// App
import loader from "./modules/app/Loader";
import jobs from "./modules/app/Jobs";

//Billar
import recurring from './modules/recurring/recurringCycle';
import invoice from "./modules/invoice/invoice";
import paymentMethod from "./modules/paymentMethod/paymentMethod";
import tax from "./modules/tax/taxes";
import clientUser from "./modules/Additional/additional";
import category from './modules/category/category';
import country from './modules/country/country';

Vue.use(Vuex);

export default new Vuex.Store({

    state: {
        loading: false,
        settings: {
            dateFormat: formatted_date(),
            timeFormat: parseInt(formatted_time())
        },
        theme: {
            darkMode: false
        }
    },

    getters: {},

    actions: {
        setLoader({ commit }, loading) {
            commit('SET_LOADER', loading)
        }
    },

    mutations: {
        SET_LOADER(state) {
            state.loading = !state.loading;
        }
    },

    modules: {
        support: Support,
        notifications: Notifications,
        user: User,
        notification: Notification,
        notification_event: NotificationEvent,
        // settings: Settings,
        role: Role,
        custom_field: CustomField,
        profile: Profile,
        tenant_settings: TenantSettings,
        department: Department,
        departments: Departments,
        designations: Designations,
        working_shifts: WorkingShifts,
        roles: Roles,
        employment_statuses: EmploymentStatuses,
        employees: Employees,
        calendar: CalendarFilter,
        payrun: Payrun,
        ActivityType,
        Person,
        Tags,
        ContactType,
        PhoneEmailType,
        Owner,
        Status,
        Additional,
        Pipeline,
        Stage,
        Organization,
        Example,
        Deal,
        CheckEmailSetting,
        PhoneNumber,
        Language,

        dashboard,
        stats,
        //Recrutter
        // theme,
        // settings,
        userAndRoles,
        notificationSettings,
        statuses,
        // App
        loader,
        jobs,
        campaign,
        segment,
        lists,
        subscriber,
        //Billar
        recurring,
        invoice,
        paymentMethod,
        tax,
        clientUser,
        category,
        country,
        // additional
    }
});
